/**
 * ============================================================
 * COMBO PRODUCT FORM HANDLER
 * ============================================================
 *
 * Enhances the standard product-form to handle combo products
 * with multi-item size selection. Works by intercepting form
 * submission and validating size selections.
 *
 * Revenue-safe: Does not modify existing cart functionality
 * ============================================================
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Check if this is a combo product page (look for unified combo items)
    const comboItemsUnified = document.querySelector('.combo-items-unified');
    if (!comboItemsUnified) {
      // Not a combo product page, exit
      return;
    }

    console.log('Combo Product: Initializing size validation');

    // Find the product form
    const productForm = document.querySelector('product-form');
    if (!productForm) {
      console.error('Combo Product: product-form element not found');
      return;
    }

    const form = productForm.querySelector('form');
    if (!form) {
      console.error('Combo Product: form element not found');
      return;
    }

    // Get all combo size selectors
    const sizeSelects = document.querySelectorAll('.combo-size-select');
    const errorContainer = document.querySelector('.combo-size-error');

    console.log(`Combo Product: Found ${sizeSelects.length} size selectors`);

    if (sizeSelects.length === 0) {
      console.log('Combo Product: No size selectors found, skipping validation');
      return;
    }

    // Create hidden inputs in the form for each size selector
    sizeSelects.forEach(select => {
      const existingHidden = form.querySelector(`input[name="${select.name}"]`);
      if (existingHidden) {
        existingHidden.remove();
      }

      // Create a hidden input in the form
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = select.name;
      hiddenInput.className = 'combo-size-hidden-input';
      hiddenInput.dataset.itemName = select.dataset.itemName;
      hiddenInput.value = select.value || '';
      form.appendChild(hiddenInput);

      // Update hidden input when select changes
      select.addEventListener('change', function() {
        hiddenInput.value = this.value;
        console.log(`Combo Product: Size changed - ${this.dataset.itemName}: ${this.value}`);

        // Clear error styling
        this.style.borderColor = '';

        // Clear error message if all sizes are now selected
        const allSelected = Array.from(sizeSelects).every(s => s.value && s.value !== '');
        if (allSelected && errorContainer) {
          errorContainer.style.display = 'none';
        }
      });
    });

    // Find all buttons that can submit the form
    const addToCartBtn = productForm.querySelector('[name="add"]') ||
                         productForm.querySelector('button[type="submit"]') ||
                         productForm.querySelector('.product-form__submit');

    // Intercept click on Add to Cart button
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(evt) {
        if (!validateSizes()) {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          return false;
        }
      }, true);
    }

    // Also intercept form submission
    form.addEventListener('submit', function(evt) {
      if (!validateSizes()) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        return false;
      }

      // Sync all hidden inputs before submission
      sizeSelects.forEach(select => {
        const hiddenInput = form.querySelector(`input[name="${select.name}"]`);
        if (hiddenInput) {
          hiddenInput.value = select.value;
        }
      });

      console.log('Combo Product: All sizes selected, proceeding with submission');

      // Log properties for debugging
      const formData = new FormData(form);
      
      for (let [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          console.log(`  ${key}: ${value}`);
        }
      }
    }, true);

    function validateSizes() {
      // Get all required size selections
      const requiredSelects = Array.from(sizeSelects).filter(
        select => select.hasAttribute('required')
      );

      const missing = [];

      requiredSelects.forEach(select => {
        if (!select.value || select.value === '' || select.value === 'Select Size') {
          const itemName = select.dataset.itemName || 'Item';
          missing.push(itemName);
          // Highlight the select
          select.style.borderColor = '#dc2626';
          select.style.boxShadow = '0 0 0 3px rgba(220, 38, 38, 0.2)';
        }
      });

      // If any sizes are missing, show error
      if (missing.length > 0) {
        console.log('Combo Product: Missing size selections:', missing);

        // Show error message
        if (errorContainer) {
          errorContainer.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0;">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span>Please select size for: <strong>${missing.join(', ')}</strong></span>
          `;
          errorContainer.style.display = 'flex';

          // Scroll to error
          errorContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        } else {
          alert(`Please select sizes for: ${missing.join(', ')}`);
        }

        return false;
      }

      return true;
    }

    // Also handle Buy it Now button if it exists
    const buyNowBtn = document.querySelector('.shopify-payment-button button');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function(evt) {
        if (!validateSizes()) {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          return false;
        }
      }, true);
    }

    console.log('Combo Product: Validation handler attached successfully');
  }
})();
